import { createContext } from 'react'

const ParagraphContext = createContext()

export default ParagraphContext
